import './MapCMGeometryRemoved.less';
import { Layer, Marker, Source } from 'react-map-gl';
import { Feature } from '../../../models/Geoserver';
import { useAppDispatch, useAppSelector } from '../../../store/hooks/hooks';
import { clearFeatureRemoved, selectFeatureRemoved } from '../../../store/slice/mapLayersSlice';
import { useEffect, useMemo, useState } from 'react';
import Icon from '@ant-design/icons';
import { ReactComponent as Check } from '../../../res/svg/delete-geometry-circle.svg';
import { getPolygonCenter } from '../../../utils/GeometryUtils';

const dummyLine = {
  type: 'Feature',
  geometry: {
    type: 'LineString',
    coordinates: [[0, 0], [1, 1]],
  },
  properties: {},
};

function MapCMGeometryRemoved() {

  const featureRemoved: Feature | undefined = useAppSelector(
    selectFeatureRemoved,
  );

  const [visible, setVisible] = useState(false);
  const disptach = useAppDispatch();

  useEffect(() => {
    if (featureRemoved) {
      setVisible(true);
      setTimeout(() => {
        setTimeout(() => disptach(clearFeatureRemoved()), 500);
        setVisible(false);
      }, 1000);
    }
  }, [featureRemoved, disptach]);

  const featureCenter = useMemo((): number[] => {
    return getPolygonCenter(featureRemoved);
  }, [featureRemoved]);


  return (
    <div>
      <Marker longitude={featureCenter[0]} latitude={featureCenter[1]}>
        <Icon style={{
          opacity: visible ? 1 : 0, transition: 'all 0.4s',
        }} className={'at-map-cm-removed__icon'} component={Check} />
      </Marker>
      <Source id={'MapCMGeometryRemovedSource'}
              type='geojson' data={(featureRemoved ? featureRemoved : dummyLine) as any}>

        {['MultiPolygon', 'Polygon'].includes(featureRemoved?.geometry.type ?? '') ?
          <Layer beforeId={'order-current-line'} id={'MapCMGeometryRemovedSourceFill'} type={'fill'} paint={{
            'fill-color': '#F03C5A',
            'fill-opacity': visible ? 0.8 : 0,
            'fill-opacity-transition': visible ? { duration: 0 } : { duration: 400 },
          }}
          />
          : null}
        <Layer beforeId={'order-current-line'} id={'MapCMGeometryRemovedSourceLine'} type={'line'} paint={{
          'line-color': '#9b142b',
          'line-width': 5,
          'line-opacity': visible ? 1 : 0,
          'line-opacity-transition': visible ? { duration: 0 } : { duration: 400 },
        }}
        />
        {['MultiPoint', 'Point'].includes(featureRemoved?.geometry.type ?? '') ?
          <Layer beforeId={'order-current-line'} id={'MapCMGeometryRemovedSourceCircle'} type={'circle'} paint={{
            'circle-color': '#F03C5A',
            'circle-opacity': visible ? 0.8 : 0,
            'circle-stroke-opacity': visible ? 0.8 : 0,
            'circle-opacity-transition': visible ? { duration: 0 } : { duration: 400 },
            'circle-stroke-opacity-transition': visible ? { duration: 0 } : { duration: 400 },
            'circle-stroke-color': 'white',
            'circle-stroke-width': 2,
            'circle-radius': 6,
          }}
          />
          : null}
      </Source>

    </div>
  );
}

export default MapCMGeometryRemoved;
